export const COMMON = {
  OPT_ERROR: 'COMMON_OPT_ERROR',
  TOGGLE_SIDER: 'TOGGLE_SIDER',
  GET_TASK_PROGRESS: 'GET_TASK_PROGRESS', // 获取项目进度
  GET_SIDE_NAV: 'GET_SIDE_NAV', // 动态菜单
  SET_SPA: 'SET_SPA'
};

export const LOGIN = {
  GET_LOGIN_INFO_BY_CODE: 'GET_LOGIN_INFO_BY_CODE',
  REFRESH_ACCESS_TOKEN: 'REFRESH_ACCESS_TOKEN',
  CHECK_CUSTOMISE: 'CHECK_CUSTOMISE',
  BUTTON_PERMISSIONS: 'BUTTON_PERMISSIONS',
};

// 任务管理
export const TASKMANAGE = {
  GET_TASK_FIRSTPAGE_LIST: 'GET_TASK_FIRSTPAGE_LIST', // 首页-概况-列表
  GET_TASK_FIRSTPAGE_OUTSTATUS_LIST: 'Get_TASK_FIRSTPAGE_OUTSTATUS_LIST', // 首页-输出状态-列表
  GET_TASK_LIST_WORD_STRATEGY_ID_OPTIONS:
    'GET_TASK_LIST_WORD_STRATEGY_ID_OPTIONS', // 任务列表-话术名称下拉框
  GET_TASK_LIST_PHONE_OPTIONS: 'GET_TASK_LIST_PHONE_OPTIONS', // 任务列表-编辑弹框-主叫号码下拉框
  GET_TASK_LIST_STRATEGY_OPTIONS: 'GET_TASK_LIST_STRATEGY_OPTIONS', // 任务列表-编辑弹框-主叫号码下拉框
  TASK_LIST_DEPT: 'TASK_LIST_DEPT', // 部门树
  GET_TASK_LIST_WORK_TIME_OPTIONS: 'GET_TASK_LIST_WORK_TIME_OPTIONS', // 任务列表-编辑弹框-工作时间下拉框
  SET_TASK_LIST_SEARCH_DATA: 'SET_TASK_LIST_SEARCH_DATA', // 任务列表-设置搜索条件
  SET_TASK_LIST_TAB_ACTIVE_KEY: 'SET_TASK_LIST_TAB_ACTIVE_KEY', // 任务列表-设置tab的activeKey
  GET_TASK_LIST_LIST: 'GET_TASK_LIST_LIST', // 任务列表-table列表
  SET_TASK_LIST_PAGE_STATUS: 'SET_TASK_LIST_PAGE_STATUS', // 任务列表-设置pageNum与pageSize
  SET_TASK_LIST_EDIT_MODAL_DATA: 'SET_TASK_LIST_EDIT_MODAL_DATA', // 任务列表-设置编辑弹框数据
  TASK_LIST_EDIT_TASK: 'TASK_LIST_EDIT_TASK', // 任务列表-编辑弹框-点击确定
  TASK_LIST_CONFIRM_PAUSE: 'TASK_LIST_CONFIRM_PAUSE', // 任务列表-确认暂停任务
  TASK_LIST_START_UP: 'TASK_LIST_START_UP', // 任务列表-启动任务
  TASK_LIST_CONFIRM_CANCEL: 'TASK_LIST_CONFIRM_CANCEL', // /任务列表-取消
  TASK_LIST_COMFIRM_UPLOAD: 'TASK_LIST_COMFIRM_UPLOAD', // 任务管理-任务列表-数据导入
  TASK_LIST_COMFIRM_DELETCHECK: 'TASK_LIST_COMFIRM_DELETCHECK', // 任务管理-任务列表-数据删除检测
  TASK_LIST_COMFIRM_DELET: 'TASK_LIST_COMFIRM_DELET', // 任务管理-任务列表-数据删除

  GET_TASK_DETAIL_TASK_NAME_OPTIONS: 'GET_TASK_DETAIL_TASK_NAME_OPTIONS', // 任务详情-任务名称下拉框
  GET_TASK_DETAIL_WORD_STRATEGY_ID_OPTIONS:
    'GET_TASK_DETAIL_WORD_STRATEGY_ID_OPTIONS', // 任务详情-话术名称下拉框
  SET_TASK_DETAIL_SEARCH_DATA: 'SET_TASK_DETAIL_SEARCH_DATA', // 任务详情-设置搜索条件
  SET_TASK_DETAIL_SELECTD_ROW_KEYS: 'SET_TASK_DETAIL_SELECTD_ROW_KEYS', // 任务管理-任务详情-设置列表筛选项
  GET_TASK_DETAIL_LIST: 'GET_TASK_DETAIL_LIST', // 任务详情-table列表
  SET_TASK_DETAIL_PAGE_STATUS: 'SET_TASK_DETAIL_PAGE_STATUS', // 任务详情-设置pageNum与pageSize
  TASK_DETAIL_CONFIRM_CALL: 'TASK_DETAIL_CONFIRM_CALL', // 任务详情-拨打电话
  TASK_DETAIL_BATCH_PAUSE: 'TASK_DETAIL_BATCH_PAUSE', // 任务详情-批量暂停
  TASK_DETAIL_BATCH_CONTINUE: 'TASK_DETAIL_BATCH_CONTINUE', // 任务详情-批量继续
  TASK_DETAIL_BATCH_CANCEL: 'TASK_DETAIL_BATCH_CANCEL', // 任务详情-批量取消
  TASK_DETAIL_BATCH_CALL: 'TASK_DETAIL_BATCH_CALL', // 任务详情-批量呼叫
  GET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA: 'GET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA',// 任务详情-获取通话详情抽屉数据-问答
  SET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA: 'SET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA',// 任务详情-获取通话详情抽屉数据-问答保存
  GET_TASK_DETAIL_DETAIL_HEADER_CUSTOMCOLUMN: 'GET_TASK_DETAIL_DETAIL_HEADER_CUSTOMCOLUMN',//查询单任务的任务详情时, 提前获取任务的业务列

  GET_TASK_DETAIL_DETAIL_DRAWER_DATA: 'GET_TASK_DETAIL_DETAIL_DRAWER_DATA', // 任务详情-获取通话详情抽屉数据
  SET_TASK_DETAIL_DETAIL_DRAWER_DATA: 'SET_TASK_DETAIL_DETAIL_DRAWER_DATA', // 任务详情-设置通话详情抽屉数据
  CUSTOMIZE_SMG_TEMPLATES: 'CUSTOMIZE_SMG_TEMPLATES', // 短信模板下拉选接口
  GET_CUSTOMIZE_TASK_LIST: 'GET_CUSTOMIZE_TASK_LIST', // 定制化企业查询任务列表分页接口
  GET_CUSTOMIZE_TASK_DETAIL_LIST: 'GET_CUSTOMIZE_TASK_DETAIL_LIST', // 定制化企业查询任务详情列表
  POST_CORRECT_LABEL: 'POST_CORRECT_LABEL', //  呼叫详情标签纠错
  POST_TASK_DETAIL_EXPORT: 'POST_TASK_DETAIL_EXPORT',
  TASK_DETAIL_RECALL: 'TASK_DETAIL_RECALL',
  GET_BATCH_OPTIONS: 'GET_BATCH_OPTIONS',
  SET_TASK_DETAIL_RECALL_DATA: 'SET_TASK_DETAIL_RECALL_DATA',

  GET_TASK_QUESTIONNAIRE_CONNECT_PIE: 'GET_TASK_QUESTIONNAIRE_CONNECT_PIE', // 问卷统计-饼图数据
  GET_TASK_QUESTIONNAIRE_ANSWER_BAR: 'GET_TASK_QUESTIONNAIRE_ANSWER_BAR', // 问卷统计-柱状数据
  GET_TASK_QUESTIONNAIRE_RESULT: 'GET_TASK_QUESTIONNAIRE_RESULT', // 问卷统计-表格数据
  SET_TASK_QUESTIONNAIRE_SEARCH_DATA: 'SET_TASK_QUESTIONNAIRE_SEARCH_DATA', // 问卷统计-查询数据
  SET_TASK_QUESTIONNAIRE_PAGE_STATUS: 'SET_TASK_QUESTIONNAIRE_PAGE_STATUS', // 问卷统计-分页数据
  GET_TASK_QUESTIONNAIRE_HEAD: 'GET_TASK_QUESTIONNAIRE_HEAD', // 表头数据
  POST_QUESTIONNAIRE_PAGE_EXPORT: 'POST_QUESTIONNAIRE_PAGE_EXPORT',
  SET_TABLEHEAD_SEARCH_DATA: 'SET_TABLEHEAD_SEARCH_DATA', // 表头搜索数据
  GET_RANDOM_TOKEN: 'GET_RANDOM_TOKEN',//随机生成token
  GET_LIST_TONE: 'GET_LIST_TONE',//音色列表
  GET_TASK_LIST_ALL: 'GET_TASK_LIST_ALL',//项目列表
  POST_TASK_MONITORING: 'POST_TASK_MONITORING',//监控数据
  SET_MONITORING_ID: 'SET_MONITORING_ID',//监控任务id
  TASK_DETAIL_BATCH_CANCEL_ALL: 'TASK_DETAIL_BATCH_CANCEL_ALL',// 任务详情 全部取消
  UPDATE_SLOTMAP_VAL: 'UPDATE_SLOTMAP_VAL', //云问更新抽取信息字段

  // 交互轨迹页面
  GET_PAGE_LIST: "GET_PAGE_LIST", //获取页面列表数据
  SET_STATE: "SET_STATE",//更改state属性值
  GET_DETAIL_COUNT: "GET_DETAIL_COUNT",//交互分析饼图请求
  GET_DETAIL_LIST: "GET_DETAIL_LIST",//交互分析列表请求
  INTERACT_DOWNLOAD: "INTERACT_DOWNLOAD",//交互轨迹导出
  INTERACT_DETAIL_DOWNLOAD: "INTERACT_DETAIL_DOWNLOAD",//交互轨迹详情导出
};

// 系统设置
export const SYSTEMSETTING = {
  GET_WORK_TIME_LIST: 'GET_WORK_TIME_LIST', // 工作时间-列表
  SET_WORK_TIME_PAGE_STATUS: 'SET_WORK_TIME_PAGE_STATUS', // 工作时间-设置pageNum与pageSize
  DELETE_WORK_TIME: 'DELETE_WORK_TIME', // 工作时间-删除
  SET_WORK_TIME_EDIT_MODAL_DATA: 'SET_WORK_TIME_EDIT_MODAL_DATA', // 工作时间-设置编辑弹框数据
  GET_WORK_TIME_EDIT_MODAL_DATA: 'GET_WORK_TIME_EDIT_MODAL_DATA', // 工作时间-获取编辑弹框数据
  EDIT_WORK_TIME: 'EDIT_WORK_TIME', // 工作时间-编辑弹框-点击确定

  GET_TALKING_SKILL_LIST: 'GET_TALKING_SKILL_LIST', // 话术列表-列表
  SET_TALKING_SKILL_PAGE_STATUS: 'SET_TALKING_SKILL_PAGE_STATUS', // 话术列表-设置pageNum与pageSize
  SET_TALKING_SKILL_CONFIG_MODAL_DATA: 'SET_TALKING_SKILL_CONFIG_MODAL_DATA', // 话术列表-获取配置弹框的数据
  CONFIG_TALKING_SKILL: 'CONFIG_TALKING_SKILL', // 话术列表-配置/添加
  GET_TALKING_SKILL_AI_APP_OPTIONS: 'GET_TALKING_SKILL_AI_APP_OPTIONS', // 话术列表-配置话术-ai应用下拉框
  GET_TALKING_SKILL_APP_CHANNEL_OPTIONS:
    'GET_TALKING_SKILL_APP_CHANNEL_OPTIONS', // 系统设置-话术列表-配置话术-应用渠道下拉框
  GET_TASKING_SKILL_YUNWEN_CHANNELS: 'GET_TASKING_SKILL_YUNWEN_CHANNELS',
  GET_TASKING_SKILL_YUNWEN_SCENES: 'GET_TASKING_SKILL_YUNWEN_SCENES',

  GET_ADMINISTRATORS: 'GET_ADMINISTRATORS',
  GET_CALLING_NUMBER_LIST: 'GET_CALLING_NUMBER_LIST', // 主叫号码-列表
  TASK_LIST_DEPT: 'TASK_LIST_DEPT', // 部门树
  SET_CALLING_NUMBER_PAGE_STATUS: 'SET_CALLING_NUMBER_PAGE_STATUS', // 主叫号码-设置pageNum与pageSize
  SET_CALLING_NUMBER_EDIT_MODAL_DATA: 'SET_CALLING_NUMBER_EDIT_MODAL_DATA', // 主叫号码-设置编辑弹框数据
  EDIT_CALLING_NUMBER: 'EDIT_CALLING_NUMBER', // 主叫号码-编辑弹框-点击确定
  DELETE_CALLING_NUMBER: 'DELETE_CALLING_NUMBER', // 主叫号码-删除

  GET_EXPORT_TASK_LIST: 'GET_EXPORT_TASK_LIST', // 数据导出任务-列表
  SET_EXPORT_TASK_PAGE_STATUS: 'SET_EXPORT_TASK_PAGE_STATUS', // 数据导出任务-列表
  EXPORT_TASK_DELET: 'EXPORT_TASK_DELET', // 数据导出任务-删除
  SET_EXPORT_TASK_RELOAD: 'SET_EXPORT_TASK_RELOAD', // 数据导出任务-重新开始
  EXPORT_TASK_RELOAD: 'EXPORT_TASK_RELOAD', // 数据导出任务-重新开始
  EXPORT_TASK_CANCEL: 'EXPORT_TASK_CANCEL', // 数据导出任务-取消
  SET_EXPORT_TASK_DOWNLOAD: 'SET_EXPORT_TASK_DOWNLOAD', // 数据导出任务-下载

  POST_USER_LIST: 'POST_USER_LIST', // 用户列表
  GET_USER_ROLE_SELECT: 'GET_USER_ROLE_SELECT',// 用户列表选择
  POST_USER_ROLEBINDING: 'POST_USER_ROLEBINDING',// 新增用户

  SET_NEW_ROLE_PAGE_STATUS: 'SET_NEW_ROLE_PAGE_STATUS', // 角色管理翻页
  SET_NEW_ROLE_CONFIG_MODAL_DATA: 'SET_NEW_ROLE_CONFIG_MODAL_DATA', // 角色管理添加编辑角色弹窗
  SET_ADD_USER_CONFIG_MODAL_DATA: 'SET_ADD_USER_CONFIG_MODAL_DATA', // 角色管理添加用户弹窗
  GET_NEW_ROLE_LIST: 'GET_NEW_ROLE_LIST', // 角色管理角色列表
  GET_USER_LIST: 'GET_USER_LIST', // 角色管理用户列表
  GET_ROLE_PERMIT: 'GET_ROLE_PERMIT', // 角色管理角色权限
  DELETE_NEW_ROLE: 'DELETE_NEW_ROLE', // 角色管理删除角色
  SET_NEW_ROLE: 'SET_NEW_ROLE', // 角色管理添加编辑角色
  SET_USER_BINDING: 'SET_USER_BINDING', // 角色管理添加用户
  GET_DEPART_PERMIT: 'GET_DEPART_PERMIT', // 部门树
  GET_SOUND_MARKET_LIST: 'GET_SOUND_MARKET_LIST',//音色市场 声音列表
  GET_SOUND_MARKET_URL: 'GET_SOUND_MARKET_URL',//音色市场 URL播放
};

// AI优化
export const AI = {
  GET_WORD_STRATEGY_ID_OPTIONS: 'GET_WORD_STRATEGY_ID_OPTIONS', // 问题学习-话术名称下拉框
  SET_QUESTION_STUDY_SEARCH_DATA: 'SET_QUESTION_STUDY_SEARCH_DATA', // 问题学习-搜索条件
  SET_QUESTION_STUDY_TAB_ACTIVE_KEY: 'SET_QUESTION_STUDY_TAB_ACTIVE_KEY', // 问题学习-设置tab的activeKey
  GET_QUESTION_STUDY_LIST: 'GET_QUESTION_STUDY_LIST', // 问题学习-列表
  SET_QUESTION_STUDY_PAGE_STATUS: 'SET_QUESTION_STUDY_PAGE_STATUS', // 问题学习-设置pageNum与pageSize
  SET_QUESTION_STUDY_STUDY: 'SET_QUESTION_STUDY_STUDY', // 问题学习-学习
  SET_QUESTION_STUDY_IGNORE: 'SET_QUESTION_STUDY_IGNORE', // 问题学习-忽略
  GET_QUESTION_STUDY_DETAIL_DRAWER_DATA:
    'GET_QUESTION_STUDY_DETAIL_DRAWER_DATA', // 问题学习-查看详情-通话详情抽屉数据
};

export const TASKSTATISTIC = {
  POST_TASK_STATISTIC_LIST: 'POST_TASK_STATISTIC_LIST', // 任务统计列表
  POST_TASK_STATISTIC_EXPORT: ' POST_TASK_STATISTIC_EXPORT',
  POST_TASK_STATISTIC_TOTAL: ' POST_TASK_STATISTIC_TOTAL',
};

export const ENTERPRISE = {
  GET_COMPANY_INFO_LIST: 'GET_COMPANY_INFO_LIST', // 公司任务配置-列表
  SET_COMPANY_INFO_CONFIG_MODAL_DATA: 'SET_COMPANY_INFO_CONFIG_MODAL_DATA', // 公司任务配置-获取配置弹框的数据
  ADD_COMPANY_INFO: 'ADD_COMPANY_INFO', // 公司任务配置-添加
  CONFIG_COMPANY_INFO: 'CONFIG_COMPANY_INFO', // 公司任务配置-编辑
};
